import { defineMessages } from 'react-intl';

export default defineMessages({
  orderId: {
    id: 'account.orderHistory.detail.id',
    defaultMessage: 'Reference Number',
  },
  orderDate: {
    id: 'account.orderHistory.detail.date',
    defaultMessage: 'Order Date',
  },
  orderStatus: {
    id: 'account.orderHistory.detail.status',
    defaultMessage: 'Status',
  },
});
